import b_ from 'b_';

export const b = b_.with('lesson-three-dots');
